export default __webpack_public_path__ + "static/media/EN.1f49813c.png";